import { HugeiconsIcon } from "@hugeicons/react";
import { SquareLock02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { cx } from "shared/utils";
import { IconAILeasingAgent } from "shared/components/ai/IconAI/icons/IconAILeasingAgent";
import { AiLeasingAgentVisibilityState } from "types/landlord/address";
import { STATE_LABELS } from "./copy";

const PILL_CLASS =
  "inline-flex h-6 items-center gap-1.5 whitespace-nowrap rounded-full border border-transparent px-2.5 text-xs font-medium";

const Dot = () => (
  <span
    aria-hidden
    className="size-[7px] shrink-0 rounded-full bg-current opacity-90"
  />
);

/** The Boom chip for each visibility state (CRM-1620). */
export const StatePill = ({
  state
}: {
  state: AiLeasingAgentVisibilityState;
}) => {
  switch (state) {
    case "visible":
      return (
        <span
          className={cx(PILL_CLASS, "bg-primary-20 pl-[3px] text-primary-500")}
        >
          <IconAILeasingAgent bgSize={18} />
          {STATE_LABELS.visible}
        </span>
      );
    case "not_connected":
    case "no_access":
      return (
        <span className={cx(PILL_CLASS, "bg-warning-50 text-warning-700")}>
          <Dot />
          {STATE_LABELS[state]}
        </span>
      );
    case "not_listed":
      return (
        <span className={cx(PILL_CLASS, "bg-alpha-40 text-content-500")}>
          <Dot />
          {STATE_LABELS.not_listed}
        </span>
      );
    case "locked":
      return (
        <span
          className={cx(
            PILL_CLASS,
            "border-alpha-100 bg-alpha-40 text-content-500"
          )}
        >
          <HugeiconsIcon
            icon={SquareLock02Icon}
            size={14}
            aria-hidden
            className="shrink-0 text-content-400"
          />
          {STATE_LABELS.locked}
        </span>
      );
  }
};
